export * from './lib/not-found-page.module';
export * from './lib/not-found-page.component';
